// Generic retry wrapper for "last chance" submission calls (test submit,
// fallback submit, independent-resultprocess). Retries on network errors and
// 5xx; does not retry on 4xx, since retrying a client error won't help.
// Same pattern already proven in saveToMongoFunction.js, extracted here so
// every last-chance call site in Test.jsx shares it instead of each getting
// exactly one try before falling through to the next fallback tier.
const DEFAULT_MAX_ATTEMPTS = 3;
const DEFAULT_BACKOFFS_MS = [500, 1000, 2000];

const postWithRetry = async (requestFn, { maxAttempts = DEFAULT_MAX_ATTEMPTS, backoffsMs = DEFAULT_BACKOFFS_MS, label = "request" } = {}) => {
  let lastError = null;

  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      const response = await requestFn();
      if (attempt > 1) {
        console.log(`✅ ${label} succeeded on attempt ${attempt}`);
      }
      return response;
    } catch (error) {
      lastError = error;
      const httpStatus = error?.response?.status;
      const isNonRetriable = httpStatus >= 400 && httpStatus < 500;
      console.log(`${label} attempt ${attempt}/${maxAttempts} failed (status=${httpStatus || "network"}):`, error?.message || error);

      if (isNonRetriable || attempt === maxAttempts) break;
      await new Promise((resolve) => setTimeout(resolve, backoffsMs[attempt - 1] ?? backoffsMs[backoffsMs.length - 1]));
    }
  }

  throw lastError;
};

export default postWithRetry;
